<template>
  <div class="dashboard__table__header__bulk">
    <div class="dashboard__table__header__bulk__wrapper">
      <div style="flex: 1;">
        <div class="bulk__sliders-row">
          <div class="title">
              {{ $t('dashboard.bulk_setup.critical_value') }}:
          </div>
          <SensorSetup
            v-for="sensor in sensors"
            :key="sensor.label"
            :sensor="sensor"
            :inline="true"
            @onChange="setSensorValues"
          />
        </div>
          <div class="title">
              {{ $t('dashboard.bulk_setup.substrate_properties') }}:
          </div>
        <div class="bulk__batches" v-if="firstSelectedWithBatch">
          <div class="bulk__batches__property" :key="property.label"
               v-for="property in firstSelectedWithBatch.batch.type.properties">
                <span class="bulk__batches__property__label">
                  {{ property.label }}:
                </span>
            <span class="bulk__batches__property__drop dropdown"
                  v-if="property.type === 'choices'">
                  <select @change="updatedProperties" v-model="bulk.properties[property.key]" :disabled="!batchesIdentical">
                    <option :value="null"></option>
                    <option v-for="choice in property.values"
                            :value="choice"
                            :key="property.key + '_' + choice"
                            :selected="bulk.properties[property.key]">
                        {{ choice }}
                    </option>
                  </select>
                </span>
          </div>
          <div class="bulk__batches__warning" v-if="batchesIdentical === false">{{ $t('dashboard.bulk_setup.batch_type_error') }}</div>
          <div class="bulk__batches__warning" v-if="batchesIdentical === null">{{ $t('dashboard.bulk_setup.batch_missing_error') }}</div>
          <div class="bulk__batches__info" v-if="checkBulkProps && batchesIdentical">{{ $t('dashboard.bulk_setup.batch_all_error') }}</div>
        </div>
        <table>
          <tr v-if="!saMixedWithRegular">
            <td>
              <div class="title">
                  {{ $t('dashboard.bulk_setup.frame_selection') }}:
              </div>
              <div class="bulk__payloads">
                <div class="bulk__payloads__formats">
                  <span class="bulk__payloads__formats__label">
                    {{ $t('detail.payload_format') }}
                  </span>
                    <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.userType" @change="isFrameOk()" v-bind:class="{'warning': this.frameMessage }">
                      <option :value="null"></option>
                      <option v-for="(format, type) in firstSelectedPayloadFormats.payload.payloadFormats"
                              :value="type"
                              :key="format.name"
                              :selected="null">
                          {{ format.name }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </td>

            <td>
              <div class="bulk__payloads" v-if="selfAwarenessOff">
                <div class="bulk__payloads__formats">
                      <span class="bulk__payloads__formats__label">
                        {{ $t('detail.measurement_sets') }}
                      </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.userMessagesInInterval" @change="isFrameOk()" v-bind:class="{'warning': this.frameMessage }">
                      <option :value="null"></option>
                      <option v-for="value of accMeasurementsSets"
                              v-bind:key="value"
                              :value="value"
                              :selected="null">
                          {{ value }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
                <div class="bulk__payloads" v-if="!selfAwarenessOff">
                <div class="bulk__payloads__formats">
                      <span class="bulk__payloads__info">
                        {{ $t('dashboard.bulk_setup.measurement_sets_cant') }}
                      </span>
                </div>
              </div>
            </td>

            <td>
              <div class="bulk__payloads" v-if="versionsIdentical">
                <div class="bulk__payloads__formats">
                      <span class="bulk__payloads__formats__label">
                        {{ $t('detail.measurement_interval') }}
                      </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.userOmittedMessages" @change="isFrameOk()" v-bind:class="{'warning': this.frameMessage }">
                      <option :value="null"></option>
                      <option v-for="(value, index) in measurementIntervals"
                              v-bind:key="index"
                              :value="index"
                              :selected="null">
                          {{ value }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </td>
              <td>
              <div class="bulk__payloads">
                  <div class="bulk__payloads__formats"
                       v-if="versionsIdentical && firstSelectedIsMinutes">
                      <span class="bulk__payloads__formats__label">
                        {{ $t('detail.measurement_interval_span') }}
                      </span>
                      <span class="bulk__payloads__formats__drop dropdown">
                    <select name="measurementIntervalSpan"
                            v-model="bulk.userMeasurementIntervalSpan" id="measurementIntervalSpan">
                      <option :value="null"></option>
                      <option v-for="value of firstSelectedMinuteOptions" v-bind:key="value"
                              :value="value">{{ value }}</option>
                    </select>
                  </span>
                  </div>
                <div class="bulk__payloads__formats" v-if="!versionsIdentical">
                    <span class="bulk__payloads__info">
                      {{ $t('dashboard.bulk_setup.measurement_interval_cant') }}
                    </span>
                </div>
              </div>
            </td>
            <td>
              <div class="bulk__payloads" v-if="versionsIdentical && selfAwarenessOff">
                <div class="bulk__payloads__formats">
                      <span class="bulk__payloads__formats__label">
                        {{ $t('detail.downlik_period') }}
                      </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.downlinkPeriod" @change="isFrameOk()" v-bind:class="{'warning': this.frameMessage }">
                      <option :value="null"></option>
                      <option v-for="period of downlinkPeriods"
                              v-bind:key="period.value"
                              :value="period.value"
                              :selected="null">
                          {{ period.label }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </td>
              <td>
              <div class="bulk__payloads" v-if="selfAwarenessOff">
                <div class="bulk__payloads__formats">
                      <span class="bulk__payloads__formats__label">
                        {{ $t('detail.downlink_retries') }}
                      </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <select v-model="bulk.downlinkRetries" @change="isFrameOk()">
                      <option :value="null"></option>
                      <option v-for="item of downlinkRetries"
                              v-bind:key="item"
                              :value="item"
                              :selected="null">
                          {{ item }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="!saMixedWithRegular">
            <td>
              <div class="bulk__payloads" v-if="selfAwarenessOff">
                <div class="bulk__payloads__formats">
                  <span class="bulk__payloads__formats__label">
                    {{ $t('detail.message_interval') }}
                  </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    <span>{{messageInterval}}</span>
                    <input id="message_interval" style="visibility: hidden" type="text" disabled :value="messageInterval">
                  </span>
                </div>
              </div>
            </td>

            <td>
              <div class="bulk__payloads" v-if="versionsIdentical && selfAwarenessOff">
                <div class="bulk__payloads__formats">
                  <span class="bulk__payloads__formats__label lifespan">
                    {{ $t('detail.device_lifespan') }}
                  </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    {{deviceLifespan}} <span>({{ $t('dashboard.bulk_setup.hundred_tx_power') }})</span>
                    <input id="device_lifespan" style="visibility: hidden" type="text" disabled :value="deviceLifespan">
                  </span>
                </div>
                  <div class="bulk__payloads__formats">
                  <span class="bulk__payloads__formats__label lifespan">
                    {{ $t('detail.device_loralifespan') }}
                  </span>
                  <span class="bulk__payloads__formats__drop dropdown">
                    {{loraDeviceLifespan}} <span>({{ $t('dashboard.bulk_setup.hundred_tx_power') }})</span>
                    <input id="device_lifespan" style="visibility: hidden" type="text" disabled :value="loraDeviceLifespan">
                  </span>
                </div>
              </div>
              <div class="bulk__payloads__info" v-if="!versionsIdentical && selfAwarenessOff">{{ $t('dashboard.bulk_setup.version_error') }} </div>
              <div class="bulk__payloads__info" v-if="!selfAwarenessOff && versionsIdentical">{{ $t('dashboard.bulk_setup.sa_error') }} </div>
              <div class="bulk__payloads__info" v-if="!selfAwarenessOff && !versionsIdentical">{{ $t('dashboard.bulk_setup.sa_version_error') }} </div>
            </td>
          </tr>
            <tr>
                <td>
                    <div class="title">
                        {{ $t('detail.sa_title') }}:
                    </div>
                    <div class="bulk__payloads">
                        <div class="bulk__payloads__formats" v-if="versionsIdentical">
                          <span class="bulk__payloads__formats__label">
                            {{ $t('detail.sa_select_profile') }}
                          </span>
                          <span class="bulk__payloads__formats__drop dropdown">
                            <select v-model="bulk.saProfile">
                              <option :value="null"></option>
                              <option v-for="(saProfile) in firstSelectedPayloadFormats.version.saProfiles"
                                      :value="saProfile.id"
                                      :key="saProfile.name"
                                      :selected="0">
                                  {{ saProfile.name }}
                              </option>
                            </select>
                          </span>
                        </div>
                        <div class="bulk__payloads__info" v-if="!versionsIdentical">{{ $t('dashboard.bulk_setup.version_identical_sa_error') }} </div>
                    </div>
                </td>
            </tr>
        </table>

        <div class="title">
          {{ $t('dashboard.nav.remark') }}:
        </div>
        <div class="bulk__selects-row">
          <BaseInput v-model="bulk.remark" style="margin-right: 1.5rem;" />
        </div>
        <div class="title title-affected" v-if="showWarning">
          {{ $t('detail.warning') }}:
        </div>
          <div class="bulk__affected-devices-warning">
              <div v-if="saMixedWithRegular" class="affected-warning">
                  {{ $t('dashboard.bulk_setup.sa_mixed_error') }}
              </div>
              <div v-if="!versionsIdentical && !saMixedWithRegular" class="affected-warning">
                  {{ $t('dashboard.bulk_setup.identical_version_error') }}
              </div>
              <div class="affected-warning"
                   v-if="this.frameMessage === null && formatsIdentical === false  && !saMixedWithRegular">
                  {{ $t('dashboard.bulk_setup.payload_error') }}
              </div>
              <div class="affected-warning" v-if="this.frameMessage !== null && !saMixedWithRegular">
                  {{ this.frameMessage }}
              </div>
          </div>
        <div class="title title-affected">
          {{ $t('dashboard.bulk_setup.affected', { count: unitsID.length}) }}:
        </div>
        <div class="bulk__affected-devices-row">
            <span v-for="(name,key) in affectedDevicesNames" class="affected-name">
              {{ name }}
              <span v-if="key != affectedDevicesNames.length - 1">, </span>
            </span>
        </div>
          <BaseButton
                  @click.native="applyChanges(bulk)"
                  class="bulk__selects-row-item--mobile"
                  v-responsive.xs>
              {{ $t('buttons.apply') }}
          </BaseButton>
      </div>
      <div class="bulk__button-wrapper" v-responsive.sm.md.lg.xl>
        <BaseButton @click.native="applyChanges(bulk)">{{ $t('buttons.apply') }}</BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { dynamicTiming, dynamicSensing } from '@/config/tentacles';
import SensorSetup from '@/components/SensorSetup.vue';
import versionService from '@/services/VersionServices';

export default {
  name: 'DashboardBulkSetup',
  components: {
    SensorSetup,
    versionService,
  },
  props: {
    sensors: {
      type: Array,
      default: value => [],
    },
    unitsID: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      SOIL_3XS: 1,
      showTimSen: false,
      checkBulkProps: true,
      frameMessage: null,
      bulk: {
        dynamicTiming: null,
        dynamicSensing: null,
        remark: null,
        userType: null,
        saProfile: null,
        userMessagesInInterval: null,
        userOmittedMessages: null,
        downlinkPeriod: null,
        downlinkRetries: null,
        version: null,
        userMeasurementIntervalSpan: null,
        sensors: [],
        properties: {},
      },
    };
  },
  mounted() {
    for (let i = 0; i < this.sensors.length; i += 1) {
      this.bulk.sensors.push({ sensorId: this.sensors[i].sensorId, minCrit: null, maxCrit: null, minAttention: null, maxAttention: null });
    }
  },
  computed: {
    ...mapGetters('tentacle', ['type', 'nameFormat', 'network']),
    dynamicTiming() {
      for (let i = 0; i < dynamicTiming.length; i += 1) {
        dynamicTiming[i].name = this.$t(`timing.${dynamicTiming[i].label}`);
      }
      return dynamicTiming;
    },
    dynamicSensing() {
      for (let i = 0; i < dynamicSensing.length; i += 1) {
        dynamicSensing[i].name = this.$t(`sensing.${dynamicSensing[i].label}`);
      }
      return dynamicSensing;
    },
    affectedDevicesNames() {
      return this.unitsID.map(unit => this.nameFormat ? this.$store.getters['tentacle/unitById'](unit).name : this.$store.getters['tentacle/unitById'](unit).genericName + ' (' + this.networkName(this.$store.getters['tentacle/unitById'](unit)) + ')');
    },
    firstSelectedWithBatch() {
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.batch === null ){
          continue;
        }

        for (var key in tentacle.properties) {
          this.bulk.properties[key] = null;
        }

        return tentacle;
      }

      return false;
    },
    firstSelectedPayloadFormats() {
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.payload === null ){
          continue;
        }

        return tentacle;
      }

      return false;
    },
    firstSelectedIsMinutes() {
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.version === null ){
          return false;
        }

        return tentacle.version.minuteSelection;
      }

      return false;
    },
    firstSelectedMinuteOptions() {
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.version === null ){
          return [15];
        }

        return tentacle.version.minuteOptions;
      }

      return false;
    },
    batchesIdentical(){
      let batchType = null;
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.batch === null ){
          return null;
        }

        if (batchType === null){
          batchType = tentacle.batch.type.id;
        } else {
          if (batchType !== tentacle.batch.type.id) {
            return false;
          }
        }
      }

      return true;
    },
    versionsIdentical() {
      let versionType = null;
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.version === null ){
          return null;
        }

        if (versionType === null){
          versionType = tentacle.version.id;
        } else {
          if (versionType !== tentacle.version.id) {
            return false;
          }
        }
      }

      return true;
    },
    selfAwarenessOff() {
      for (let i = 0; i < this.unitsID.length; i += 1) {
        const tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);
        const saProfile = tentacle.saSelected.id;

        if (saProfile !== 0) {
          return false;
        }
      }

      return true;
    },
    saMixedWithRegular() {
      let hasSa = false;
      let hasRegular = false;
      for (let i = 0; i < this.unitsID.length; i += 1) {
        const tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);
        const saProfile = tentacle.saSelected.id;

        if (saProfile === 0) {
          hasSa = true;
        } else {
          hasRegular = true;
        }

        if (hasSa && hasRegular) {
          return true;
        }
      }

      return false;
    },
    showWarning() {
      const isFrameMissing = this.frameMessage === null && this.formatsIdentical === false;
      return this.saMixedWithRegular || !this.versionsIdentical || isFrameMissing || this.frameMessage !== null;
    },
    formatsIdentical() {
      let formatType = null;
      for (let i = 0; i < this.unitsID.length; i += 1) {
        let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

        if ( tentacle.payload === null ){
          return null;
        }

        if (formatType === null){
          formatType = tentacle.payload.ackType;
        } else {
          if (formatType !== tentacle.payload.ackType) {
            return false;
          }
        }
      }

      return true;
    },
    accMeasurementsSets: function() {
      let range = [];
      if (this.bulk.userType != null) {
        range = this.firstSelectedPayloadFormats.payload.payloadFormats[this.bulk.userType].options;
      }
      return range;
    },
    measurementIntervals: function () {
      const span = this.bulk.userMeasurementIntervalSpan ? this.bulk.userMeasurementIntervalSpan : this.firstMeasurementIntervalSpan();
      if (parseInt(this.bulk.userType) === 6) {
        this.bulk.userOmittedMessages = 15;
        return {15: 240};
      }

      const range = {};
      for (let i = 0; i <= 15; i += 1) {
        range[i] = (i + 1) * span;
      }
      return range;
    },
    messageInterval: function () {
      const span = this.bulk.userMeasurementIntervalSpan ? this.bulk.userMeasurementIntervalSpan : this.firstMeasurementIntervalSpan();
      let interval = ((parseInt(this.bulk.userOmittedMessages) + 1) * span) * parseInt(this.bulk.userMessagesInInterval);
      if (isNaN(interval)) {
        return "-";
      }
      return interval;
    },
    downlinkRetries: function () {
        return [0, 1, 2, 3];
    },
    downlinkPeriods: function () {
        const span = this.bulk.userMeasurementIntervalSpan ? this.bulk.userMeasurementIntervalSpan : this.firstMeasurementIntervalSpan();
        const downLinkValues = [0.25, 0.5, 1, 2];
        let minutesTillDownLink = 1440 / (((parseInt(this.bulk.userOmittedMessages) + 1) * span * parseInt(this.bulk.userMessagesInInterval)) * 255);
        let closest = 2;
        downLinkValues.forEach(value => {
            if (value >= minutesTillDownLink && value < closest) {
                closest = value;
            }
        });

      if (parseInt(this.bulk.userType) === 6 && parseInt(this.bulk.userMessagesInInterval) === 6) {
        this.bulk.downlinkPeriod = 1;
        return [{ label: this.$t('detail.once_per_day'), value: 1 }];
      } else if (parseInt(this.bulk.userType) === 6 && parseInt(this.bulk.userMessagesInInterval) === 12) {
        this.bulk.downlinkPeriod = 0.5;
        return [{ label: this.$t('detail.once_per_two'), value: 0.5 }];
      } else {
          let results = [];
          let options = [
              {
                  label: this.$t('detail.once_per_four'),
                  value: 0.25,
              },
              {
                  label: this.$t('detail.once_per_two'),
                  value: 0.5,
              },
              {
                  label: this.$t('detail.once_per_day'),
                  value: 1,
              },
              {
                  label: this.$t('detail.twice_per_day'),
                  value: 2,
              },
          ];

          options.forEach(value => {
              if (value.value >= closest) {
                  results.push(value);
                  if(parseFloat(this.bulk.downlinkPeriod) < closest) {
                      this.bulk.downlinkPeriod = closest;
                  }
              }
          });
          return results;
      }
    },
    deviceLifespan: function () {
      const maxMeasurments = {
          1: 3,
          2: 5,
          3: 5,
          4: 10,
          5: 4,
          6: 12,
          7: 2,
          8: 3,
          9: 3,
          10: 3,
      };

      var messageRatio = parseInt(this.bulk.userMessagesInInterval) / maxMeasurments[this.bulk.userType];  // maxMeasurementsInFrame is variable defining maximum measurement sets in current frame. It changes when different frame is selected.
      let messageConsumptionValue = 0.23424;
      if (messageRatio < 0.32) {
        messageConsumptionValue = 0.169824;
      } else if (messageRatio < 0.65) {
        messageConsumptionValue = 0.20496;
      }
      const unit = this.$store.getters['tentacle/unitById'](this.unitsID[0]);
      const version = unit.version;

      const sigfoxFramesTransmitted = parseInt(unit.payload.sigfoxFramesTransmitted);
      const messageIntervalValue = parseInt(this.messageInterval);
      const downlinkPeriodValue = parseFloat(this.bulk.downlinkPeriod);
      const txPowerValue = 14;
      const txCoefficientValue = 0.00137 * Math.pow(txPowerValue, 3) - 0.03852 * Math.pow(txPowerValue, 2) + 0.4025 * txPowerValue - 0.8054;

      let lifespan = NaN;

      if (version && version.batteryFormula){
        lifespan = eval(version.batteryFormula);
      }

      if (isNaN(lifespan)) {
        lifespan = (5040 / ((1.380821918 + (1440 / messageIntervalValue) * messageConsumptionValue + 0.20528 * downlinkPeriodValue) * 365));
      }

      if (isNaN(lifespan)) {
        return '-';
      }

      return lifespan.toFixed(1);
    },
    loraDeviceLifespan: function () {
      const maxMeasurments = {
          1: 3,
          2: 5,
          3: 5,
          4: 10,
          5: 4,
          6: 12,
          7: 2,
          8: 3,
          9: 3,
          10: 3,
      };

      var messageRatio = parseInt(this.bulk.userMessagesInInterval) / maxMeasurments[this.bulk.userType];  // maxMeasurementsInFrame is variable defining maximum measurement sets in current frame. It changes when different frame is selected.
      let messageConsumptionValue = 0.23424;
      if (messageRatio < 0.32) {
        messageConsumptionValue = 0.169824;
      } else if (messageRatio < 0.65) {
        messageConsumptionValue = 0.20496;
      }
      const unit = this.$store.getters['tentacle/unitById'](this.unitsID[0]);
      const version = unit.version;

      const dataRate = parseInt(unit.payload.loraDataRate);
      const messageIntervalValue = parseInt(this.messageInterval);
      const downlinkPeriodValue = parseFloat(this.bulk.downlinkPeriod);
      const txPowerValue = 14;
      const txCoefficientValue = 0.00137 * Math.pow(txPowerValue, 3) - 0.03852 * Math.pow(txPowerValue, 2) + 0.4025 * txPowerValue - 0.8054;

      let loraLifespan = NaN;

      if (version && version.loraBatteryFormula){
        loraLifespan = eval(version.loraBatteryFormula);
      }

      if (isNaN(loraLifespan)) {
          loraLifespan = (5040 / ((1.380821918 + (1440 / messageIntervalValue) * messageConsumptionValue + 0.20528 * downlinkPeriodValue) * 365));
      }

      if (isNaN(loraLifespan)) {
        return '-';
      }

      return loraLifespan.toFixed(1);
    },
  },
  methods: {
    firstMeasurementIntervalSpan() {
        for (let i = 0; i < this.unitsID.length; i += 1) {
            let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);

            if ( tentacle.version === null || tentacle.payload === null ) {
                return 15;
            }

            return tentacle.payload.userMeasurementIntervalSpan;
        }

        return false;
    },
    networkName(tentacle) {
      const deviceEui = tentacle.lora && tentacle.lora.deviceEui ? tentacle.lora.deviceEui : this.$t('dashboard.no_lora_id');
      return this.network ? deviceEui : tentacle.external;
    },
    updatedProperties() {
      this.checkBulkProps = this.checkProps(this.bulk.properties);
    },
    checkProps(props) {
      for (const key in props) {
        if (props[key] === null || props[key] === ''){
          return true;
        }
      }
      return false;
    },
    isFrameOk(){
      if (this.bulk.userType && this.selfAwarenessOff) {
        if (
          !this.bulk.userMessagesInInterval
                || !this.bulk.userOmittedMessages
                || !this.bulk.downlinkPeriod
        ) {
          this.frameMessage = this.$t('dashboard.bulk_setup.batch_all_error');
          return false;
        }
      }
      if (this.bulk.userType && !this.selfAwarenessOff) {
        if (!this.bulk.userOmittedMessages) {
          this.frameMessage = this.$t('dashboard.bulk_setup.batch_all_error');
          return false;
        }
      }

      this.frameMessage = null;
      return true;
    },
    setBulkDynamicTiming(option) {
      this.bulk.dynamicTiming = option;
    },
    setBulkDynamicSensing(option) {
      this.bulk.dynamicSensing = option;
    },
    setSensorValues(newValues) {
      this.bulk.sensors = this.bulk.sensors.map((sensor) => {
        if (sensor.sensorId === newValues.sensorId) {
          sensor.minCrit = newValues.minCrit;
          sensor.maxCrit = newValues.maxCrit;
          sensor.minAttention = newValues.minAttention;
          sensor.maxAttention = newValues.maxAttention;
        }
        return sensor;
      });
    },
    applyChanges(bulkOptions) {
      if (!this.isFrameOk()) {
        return false;
      }
      // move to function
      const newTentacles = [];
      // no for int i cycle
      for (let i = 0; i < this.unitsID.length; i += 1) {
        const tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[i]);
        let options = {
            id: this.unitsID[i],
            remark: bulkOptions.remark,
            properties: this.checkProps(bulkOptions.properties) ? null : JSON.stringify(bulkOptions.properties),
            measurementInterval: bulkOptions.dynamicTiming ? bulkOptions.dynamicTiming.value : null,
            dynamicSensing: bulkOptions.dynamicSensing ? bulkOptions.dynamicSensing.value : null,
            sensors: bulkOptions.sensors.reduce((bulkSensors, bulkSensor) => {
                const sensor = tentacle.sensors.filter(tentacleSensor => tentacleSensor.sensorId === bulkSensor.sensorId);
                if (sensor.length) {
                    bulkSensors.push({
                        id: sensor[0].id,
                        ...bulkSensor,
                    });
                }
                return bulkSensors;
            }, []),
        };

        if (bulkOptions.userType !== null) {
            options.userPayloadFormatType = bulkOptions.userType;
        }

        if (bulkOptions.userMessagesInInterval !== null) {
            options.userMessagesInInterval = bulkOptions.userMessagesInInterval;
        }

        if (bulkOptions.userOmittedMessages !== null) {
            options.userOmittedMessages = bulkOptions.userOmittedMessages;
        }

        if (bulkOptions.userMeasurementIntervalSpan !== null) {
            options.userMeasurementIntervalSpan = bulkOptions.userMeasurementIntervalSpan;
        }

        if (bulkOptions.downlinkPeriod !== null) {
            options.downlinkPeriod = bulkOptions.downlinkPeriod;
        }

        if (bulkOptions.downlinkRetries !== null) {
            options.downlinkRetries = bulkOptions.downlinkRetries;
        }

        if (bulkOptions.saProfile !== null) {
            options.selfAwarenessProfile = bulkOptions.saProfile;
        }

        newTentacles.push(options);
      }
      this.$store.dispatch('tentacle/updateUnit', newTentacles).then((response) => {
        if (response.status === 200) {
          this.flash('Tentacles updated', 'success');

          let customer = this.$store.getters['customer/customer'];
          let type = this.$store.getters['tentacle/type'];
          let tentacle = this.$store.getters['tentacle/unitById'](this.unitsID[0]);
          let params = {customer: customer, type: type};
          this.$store.dispatch('tentacle/setType', params);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
    padding-left: 1.5rem;
    color: $light-grey;
    font-size: 1.3rem;
    font-weight: 600;
}

.title-affected {
  color: $red-affected;
}

.title-not-same-versions {
  color: $red-affected;
  font-size: 1.8em;
  width: 100%;
  text-align: center;
}

.dashboard__table__header__bulk {
  background-color: $white;
  box-shadow: 0 0 1rem rgba(100, 100, 100, 0.1) inset;
  transition: all 0.4s;

  &__wrapper {
    padding: 2.5rem 1.5rem;
    display: flex;
  }

  .bulk {
    display: flex;
    align-items: stretch;
    &__sliders-row {
      margin-bottom: 3.5rem;
    }
    &__selects-row {
      padding: 0 3rem;
      display: flex;
      align-items: center;

        &-item--mobile {
            @media only screen and (max-width: 991px) {
                width:100%;
                margin-top: 2em;
            }
        }

        @media only screen and (max-width: 991px) {
            flex-direction: column;
            align-items: start;
        }
      .select {
        margin-right: 2rem;
        width: 24rem;
      }
    }
    &__affected-devices-row {
      padding: 1rem 2rem;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      @media only screen and (max-width: 991px) {

      }

      .affected-name {
        line-height: 20px;
        font-size: 14px;
        margin-left: 10px;
      }
    }

    &__affected-devices-warning {
      padding: 1rem 2rem;
      display: flex;
      flex-direction: column;

      .affected-warning {
        line-height: 27px;
        font-size: 17px;
        margin-left: 10px;
        font-weight: bold;
      }
    }

    &__button-wrapper {
      margin-left: auto;
      justify-self: end;
      padding-left: 2rem;
      display: flex;
      align-items: flex-end;

      .btn {
          width: max-content;
      }
    }

    &__batches {
      display: flex;
      align-items: center;
      margin-bottom: 2.5rem;
      padding: 1.5rem 3rem;

        &__property {
            font-size: small;
            margin-right: 3rem;

            &__drop > select {
                border: 1px solid $border-color;
                color: $middle-grey;
                background-color: $bg;
                border-radius: 3px;
                line-height: 4rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;

                :disabled {
                    color: $red-affected;
                }
            }

            &__drop > select:disabled {
                border: 1px solid $border-color;
                background-color: $bg;
                border-radius: 3px;
                line-height: 4rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;
                color: $red-affected;
            }
        }

        &__property > span {
            margin-right: 1rem;
        }


      &__warning {
        padding: 2px 15px;
        display: inline-block;
        margin-right: 2rem;
        color: $red-affected;
        font-size: medium;
      }

      &__info {
        padding: 2px 15px;
        display: inline-block;
        margin-right: 2rem;
        color: $light-grey;
        font-size: medium;
      }
    }

    &__payloads {
      display: flex;
      align-items: center;
      margin-bottom: 2.5rem;
      padding: 1.5rem 3rem;

        &__formats {
            font-size: small;
            margin-right: 3rem;

            &__drop > select {
                border: 1px solid $border-color;
                color: $middle-grey;
                background-color: $bg;
                border-radius: 3px;
                line-height: 4rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;

                :disabled {
                    color: $red-affected;
                }
            }

            &__drop > select.warning {
              color: $middle-grey;
              background-color: $bg;
              border: 1px solid $darkorange;
              border-radius: 3px;
              line-height: 4rem;
              padding: 0.3rem 1rem;
              min-width: 10rem;

              :disabled {
                color: $red-affected;
              }
            }

            &__drop > select:disabled {
                border: 1px solid $border-color;
                background-color: $bg;
                border-radius: 3px;
                line-height: 4rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;
                color: $red-affected;
            }
        }

        &__formats > span {
            margin-right: 1rem;
        }

      &__warning {
        padding: 2px 15px;
        display: inline-block;
        margin-right: 2rem;
        margin-top: 3.5rem;
        color: $darkorange;
        font-size: medium;
        min-width: 290px;
      }

      &__info {
        padding: 2px 15px;
        display: inline-block;
        margin-right: 2rem;
        margin-top: 3.5rem;
        color: $light-grey;
        font-size: medium;
        min-width: 290px;
      }
    }
  }
}
.bulk__payloads__formats__label {
  display: inline-block;
  margin-bottom: 5px;
}

.lifespan {
  width: 25rem;
}
</style>
